<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-start justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-right text-muted">
          © {{ year }}, Tous droits reservés par<a
            href="https://www.apdp.bj"
            class="font-weight-bold ml-1"
            target="_blank"
            rel="noopener"
            >APDP - Bénin</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
